import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { companyService } from '@kss/api';
import type { CompanyCreate } from '@kss/api';

const columns: BulkColumn<CompanyCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Acme Traders Pvt Ltd' },
  { key: 'code', header: 'Code', sample: 'CO-001' },
  { key: 'gstNumber', header: 'GST', sample: '22AAAAA0000A1Z5' },
  { key: 'pan', header: 'PAN', sample: 'AAAAA0000A' },
  { key: 'address', header: 'Address' },
  { key: 'logo', header: 'Logo URL' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkCompany() {
  return (
    <BulkSpreadsheet<CompanyCreate> title="Bulk import companies" entityLabel="company" backPath="/panel/companies" columns={columns} module="Company"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await companyService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
